module.exports = __webpack_public_path__ + "img/logo2.aef655c6.jpg";